import {PREFIX } from '../constants/constants'

export function prefixedURL(path: string): string {
    return (PREFIX + '/' + path).replace(/(.*\/)\/+/g, '$1');
}

export function endWithExt(str: string, ext: string): boolean {
    return str.indexOf(ext, str.length - ext.length) !== -1;
}
